import {constants} from "../../../constants";
export default class SoundOn {
    constructor(gb) {
        Object.assign(this, { gb });
    }

    PLAYTECH_handler(data) {
        if (data && data.mute && data.mute === true) {
            this.gb.emitters.emit.game.soundOff();
        } else if (data && data.mute && data.mute === false) {
            this.gb.emitters.emit.game.soundOn();
        } else {
            this.gb.emitters.emit.game.soundOn();
        }
    }

    POKERSTARS_handler(data) {
        if (data && data.keysAndValues && data.keysAndValues.soundEnabled === true) {
            this.gb.emitters.emit.game.soundOn();
        } else if (data && data.keysAndValues && data.keysAndValues.soundEnabled === false) {
            this.gb.emitters.emit.game.soundOff();
        }
    }

    _default() {
        this.gb.emitters.emit.game.soundOn();
    }

    exposeEvent() {
        let event = {};

        switch (this.gb.walletProtocol) {
            case constants.PLAYTECH:
                event["ucip.sound.w2gSoundUpdateNotification"] = this.PLAYTECH_handler;
                break;
            case constants.POKERSTARS:
                event["xc2rgPropertiesUpdated"] = this.POKERSTARS_handler;
                break;
            default:
                event["soundOn"] = this._default
        }

        return event;
    }
}
